export const SOCIAL_GALLERY_DESKTOP_NUM_ROW_ITEMS = 4;
export const SOCIAL_GALLERY_MOBILE_NUM_ROW_ITEMS = 3;
export const SOCIAL_GALLERY_MAX_ITEMS = 12;
